module.exports = __webpack_public_path__ + "img/approvedBold.2d8e2594.png";